import React, { useState, useEffect } from "react";
import api from "../../services/api";
import moment from "moment";
import BreadCrumbDiv from "../../components/common/BreadCrumbDiv";
import ButtonWrapDiv from "../../components/common/ButtonWrapDiv";
import ListWrapDiv from "../../components/common/ListWrapDiv";
import FunctionButton from "../../components/common/FunctionButton";
import { useNavigate } from "react-router-dom";
import PageBar from "../../components/common/PageBar";
import { useMenuAuthInfo } from "../../services/GlobalUtil";
import { useTranslation } from "react-i18next";
import MessageDialog from "../../components/common/MessageDialog";
import LoadingBoxDiv from "../../components/common/LoadingBoxDiv";

const UnitCodeManagementPage = () => {
  const navigate = useNavigate();
  const menuAuthInfo = useMenuAuthInfo();
  const { t } = useTranslation();
  const pageSize = 12;

  const [curPage, setCurPage] = useState(1);
  const [totalCount, setTotalCount] = useState();

  const [datas, setDatas] = useState([]);
  const [checkCodes, setCheckCodes] = useState([]);

  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (menuAuthInfo.view) {
      loadContentData();
    }
  }, [curPage]);

  const loadContentData = () => {
    setIsLoading(true);

    api
      .post("/manage/unitcode/view", {
        page: curPage,
        size: pageSize,
      })
      .then((response) => {
        setTotalCount(response.data.totalCount);
        setDatas(response.data.content);
        setIsLoading(false);
      })
      .catch(() => {});
  };

  const pageChange = (data) => {
    if (curPage === data) {
      return;
    }
    setCurPage(data);
  };

  const handleCheckValue = (e) => {
    if (e.target.checked) {
      setCheckCodes((checkCodes) => [...checkCodes, e.target.value]);
    } else {
      setCheckCodes((checkCodes) =>
        checkCodes.filter((code) => code !== e.target.value)
      );
    }
  };

  const handleAddCode = () => {
    navigate("/manage/unitcode/edit");
  };

  const handleDeleteCode = () => {
    setIsDialogOpen(true);
  };

  const handleCancel = () => {
    setIsDialogOpen(false);
  };

  const handleConfirm = () => {
    if (!checkCodes) {
      return;
    }

    api
      .post("/manage/unitcode/delete", {
        ids: checkCodes,
      })
      .then(() => {
        loadContentData();
        setCheckCodes([]);
      })
      .catch(() => {});

    setIsDialogOpen(false);
  };

  return (
    <div>
      <BreadCrumbDiv items={[t("MENU:L0056"), t("MENU:L0462")]}></BreadCrumbDiv>

      <ButtonWrapDiv className="btn_top">
        {menuAuthInfo.reg && (
          <FunctionButton
            value={t("L0321")}
            onClick={handleAddCode}
          ></FunctionButton>
        )}
        {menuAuthInfo.del && (
          <FunctionButton
            className={"bg_gray"}
            value={t("L0091")}
            onClick={handleDeleteCode}
          ></FunctionButton>
        )}
      </ButtonWrapDiv>

      <LoadingBoxDiv loading={isLoading}>
        <ListWrapDiv>
          <table>
            <thead>
              <tr>
                <th></th>
                <th>{t("L0048")}</th>
                <th>{t("L0049")}</th>
                <th>{t("L0050")}</th>
                <th>{t("L0744")}</th>
                <th>{t("L0446")}</th>
                <th>{t("L0447")}</th>
                <th>{t("L0115")}</th>
                <th>{t("L0104")}</th>
              </tr>
            </thead>
            <tbody>
              {datas.length === 0 ? (
                <tr>
                  <td colSpan={11} style={{ textAlign: "center" }}>
                    {t("L0094")}
                    <br />
                    {t("L0095")}
                  </td>
                </tr>
              ) : (
                datas.map((data, rowIndex) => (
                  <tr key={rowIndex}>
                    <td>
                      <input
                        type="checkbox"
                        name="code-check"
                        id={`code-check-${data["id"]}`}
                        value={data["id"]}
                        onChange={handleCheckValue}
                        checked={checkCodes.includes(data["id"].toString())}
                      />
                      <label htmlFor={`code-check-${data["id"]}`}></label>
                    </td>
                    <td>{t(`AREA:${data.area}`)}</td>
                    <td>{t(`UNITED:${data.united}`)}</td>
                    <td>{t(`CNTRY:${data.country}`)}</td>
                    <td>{t(`DISTANCE:${data.distance}`)}</td>
                    <td>{t(`PRESSURE:${data.pressure}`)}</td>
                    <td>{t(`TEMPERATURE:${data.temperature}`)}</td>
                    <td>{data.createId}</td>
                    <td>
                      {data.createDT ? moment(data.createDT).format("YYYY-MM-DD HH:mm:ss") : ""}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </ListWrapDiv>

        <PageBar
          TotalCount={totalCount}
          CurrentPage={curPage}
          CountPerPage={pageSize}
          MaxPageBarCount={10}
          onPageСhange={pageChange}
        ></PageBar>
      </LoadingBoxDiv>

      {isDialogOpen && (
        <MessageDialog title={"L0339"} message={t("L0096")}>
          <FunctionButton
            className="bg_gray"
            value={t("L0005")}
            onClick={handleCancel}
          ></FunctionButton>
          <FunctionButton
            value={t("L0004")}
            onClick={handleConfirm}
          ></FunctionButton>
        </MessageDialog>
      )}
    </div>
  );
};

export default UnitCodeManagementPage;
